module.exports = "/_next/static/media/6ae178ee0a05556cc30bd2d08876cbf7.svg";